/*! Slight Edition – product card color shuffle v7
 *  v8 (Oct 31): flash cards never show the same design at the same tick even with different design counts
 *  (mat 19 designs vs clutch 8): a later flash card that would clash jumps half a cycle ahead.
 *  v7 (Oct 31): flash-designs cards (mat, clutch) change every 2.5s (4s with Reduce Motion) on one shared
 *  clock, each card a fixed number of designs apart (0, 4, 2, 6 … of 8) so they never show the same design.
 *  v6
 *  v6 (Oct 31): never stalls – image load waits for the real load event with a timeout (Safari decode()
 *  can reject/hang), a watchdog restarts any card whose timer went missing, a finger scrolling past a
 *  card no longer freezes it, flash-designs cards keep a gentle crossfade under reduced motion.
 *  v5: product groups via tag group:<name>
 *  v4 (per-card start colour + phase offset + no matching neighbours;
 *  v4: products tagged "flash-designs" cycle their Design option every ~1.25s with a quicker fade)
 * Cycles each product card's image through that product's color variants.
 * Self-contained: works on top of Horizon's <product-card> markup without editing core snippets.
 */
(function () {
  'use strict';
  if (window.__seColorShuffle) return;
  window.__seColorShuffle = true;

  var CFG = Object.assign(
    { interval: 3750, jitter: 250, stagger: 650, fade: 700, resumeAfterTouch: 4000, widths: [480, 640, 800, 1024, 1200, 1600], minWidth: 800 },
    window.SE_COLOR_SHUFFLE_CONFIG || {}
  );

  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var RM = !!(rm && rm.matches); // reduced motion: colour cycling off; flash-designs cards fade slowly instead

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DATA = {};
  try {
    var el = document.getElementById('se-color-shuffle-data');
    if (el) DATA = JSON.parse(el.textContent || '{}') || {};
  } catch (e) { DATA = {}; }
  // Per-product fast cycling (products tagged "flash-designs"): { handle: intervalMs }
  var FAST = {};
  try {
    var fe = document.getElementById('se-color-shuffle-fast');
    if (fe) FAST = JSON.parse(fe.textContent || '{}') || {};
  } catch (e) { FAST = {}; }
  // Product groups (tag group:<name>): { leadHandle: { name, count, title } }. The lead card cycles every member's
  // image, links to the member on show, and is retitled "<Group name> · N designs".
  var GROUPS = {};
  try {
    var ge = document.getElementById('se-color-shuffle-groups');
    if (ge) GROUPS = JSON.parse(ge.textContent || '{}') || {};
  } catch (e) { GROUPS = {}; }

  var cards = [];
  var FAST_I = 2500, FAST_I_RM = 4000, FAST_OFF = [0, 4, 2, 6, 1, 5, 3, 7], fastN = 0;
  var STATS = { changes: 0, holds: 0, forced: 0 };
  var seq = 0;
  // Phase step between card i and card i+1 (fraction of one cycle). 3/7 keeps every card within
  // 6 places (row, column and diagonal neighbours at 2-5 across) at least 1/7 of a cycle apart.
  var STEP = 3 / 7;
  var T0 = Date.now();     // shared clock so every card keeps its own fixed phase

  // Words of a string, lowercased, padded: "Tee in Chalky Mint" -> " tee in chalky mint "
  function words(s) { return ' ' + String(s || '').toLowerCase().replace(/%20/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }
  // Which color is the card's own image? Match by URL, then the image alt, then the file name.
  // Longest color name wins so "Light Pink" beats "Pink" and "True Navy" beats "Navy".
  function startIndex(colors, img) {
    var cur = stripQuery(img.currentSrc || img.getAttribute('src'));
    for (var i = 0; i < colors.length; i++) if (stripQuery(colors[i].u) === cur) return i;
    var file = cur.split('/').pop().replace(/\.[a-z0-9]+$/i, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27,}$/i, '');
    var hay = [words(img.getAttribute('alt')), words(file)];
    for (var h = 0; h < hay.length; h++) {
      var best = -1, bestLen = 0;
      colors.forEach(function (c, i) {
        var w = words(c.c);
        if (w.length > 2 && hay[h].indexOf(w) > -1 && w.length > bestLen) { best = i; bestLen = w.length; }
      });
      if (best > -1) return best;
    }
    return 0;
  }

  function stripQuery(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); }
  function withWidth(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function srcsetFor(u) { return CFG.widths.map(function (w) { return withWidth(u, w) + ' ' + w + 'w'; }).join(', '); }
  // Width actually needed for a card: rendered CSS width x devicePixelRatio, never below CFG.minWidth.
  // (Shopify's CDN never upscales, so asking for more than the original just returns the original.)
  function needWidth(el) {
    var w = (el && el.getBoundingClientRect().width) || 400;
    var px = Math.ceil(w * (window.devicePixelRatio || 1) / 100) * 100;
    return Math.min(2048, Math.max(CFG.minWidth || 800, px));
  }
  // sizes = the card's real rendered width, so the browser picks from srcset by width x DPR
  // (the theme's sizes string says 100vw on mobile even though cards are ~2 per row).
  function sizesFor(el) {
    var w = el && el.getBoundingClientRect().width;
    return w ? Math.ceil(w) + 'px' : null;
  }
  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Normalize to [{c, v, u}] – one per color, deduped by color and by image.
  function normalize(list) {
    var seenC = {}, seenU = {}, out = [];
    (list || []).forEach(function (e) {
      if (!e || !e.u) return;
      var ck = String(e.c || '').toLowerCase(), uk = stripQuery(e.u);
      if (seenC[ck] || seenU[uk]) return;
      seenC[ck] = seenU[uk] = 1;
      out.push({ c: e.c, v: e.v, u: e.u, h: e.h });
    });
    return out;
  }

  // Fallback when the page has no Liquid data for this handle: /products/<handle>.js
  var fetchCache = {};
  function fetchColors(handle) {
    if (fetchCache[handle]) return fetchCache[handle];
    fetchCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return [];
        var idx = -1;
        (p.options || []).forEach(function (o, i) {
          var n = String(o.name || o).toLowerCase();
          if (n === 'color' || n === 'colour') idx = i;
          if (idx < 0 && FAST[handle] && (n === 'design' || n === 'style' || n === 'pattern')) idx = i;
        });
        if (idx < 0) return [];
        var key = 'option' + (idx + 1);
        var byColor = {}, order = [];
        (p.variants || []).forEach(function (v) {
          var c = v[key];
          if (!byColor[c]) { byColor[c] = []; order.push(c); }
          byColor[c].push(v);
        });
        var media = p.media || [];
        return order.map(function (c) {
          var vs = byColor[c];
          var pick = vs.filter(function (v) { return v.available; })[0] || vs[0];
          var withImg = vs.filter(function (v) { return v.featured_image; })[0];
          var u = withImg && withImg.featured_image.src;
          if (!u) {
            var lc = String(c).toLowerCase();
            var m = media.filter(function (m) { return m.alt && String(m.alt).toLowerCase().indexOf(lc) > -1; })[0];
            u = m && (m.src || (m.preview_image && m.preview_image.src));
          }
          return { c: c, v: pick && pick.id, u: u };
        });
      })
      .catch(function () { return []; });
    return fetchCache[handle];
  }

  function getColors(handle) {
    if (DATA[handle]) return Promise.resolve(DATA[handle]);
    return fetchColors(handle);
  }

  function setVariantHref(card, variantId) {
    if (!variantId) return;
    card.links.forEach(function (a) {
      var base = a.getAttribute('data-se-base-href');
      if (base == null) { base = a.getAttribute('href') || ''; a.setAttribute('data-se-base-href', base); }
      var clean = base.replace(/([?&])variant=\d+(&|$)/, '$1').replace(/[?&]$/, '');
      a.setAttribute('href', clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId);
    });
  }

  // Point the card's links at this entry: a sibling product (groups) or a variant of this product.
  function setLink(card, c) {
    if (c && c.h) {
      card.links.forEach(function (a) {
        if (a.getAttribute('data-se-base-href') == null) a.setAttribute('data-se-base-href', a.getAttribute('href') || '');
        a.setAttribute('href', c.h);
      });
      return;
    }
    setVariantHref(card, c && c.v);
  }

  function retitle(cardEl, meta) {
    if (!meta || !meta.title) return;
    var want = String(meta.title).trim();
    var label = meta.name + (meta.count > 1 ? ' \u00b7 ' + meta.count + ' designs' : '');
    Array.prototype.slice.call(cardEl.querySelectorAll('*')).forEach(function (el) {
      if (el.children.length === 0 && el.textContent.trim() === want) el.textContent = label;
    });
  }

  function setup(cardEl) {
    if (cardEl.__seCS) return;
    cardEl.__seCS = true;
    var order = seq++; // DOM order, taken before any async work so neighbours get neighbouring indexes
    var link = cardEl.querySelector('a.product-card__link, a[ref="productCardLink"], a[href*="/products/"]');
    var handle = link && handleFromHref(link.getAttribute('href'));
    if (!handle) return;
    var gallery = cardEl.querySelector('[ref="cardGallery"], .card-gallery');
    if (!gallery) return;

    getColors(handle).then(function (raw) {
      if (RM && !FAST[handle]) return;
      var colors = normalize(raw);
      if (colors.length < 2) return; // single color: stay static

      var firstImg = gallery.querySelector('slideshow-slide:not([hidden]) img, img');
      if (!firstImg) return;
      var host = firstImg.closest('.product-media') || firstImg.parentElement;

      // Start with the color the card already shows (its featured image) and rotate the
      // color order so the cycle continues from there: [start, start+1, ..., 0, ..., start-1].
      var start = startIndex(colors, firstImg);
      colors = colors.slice(start).concat(colors.slice(0, start));
      start = 0;

      var sizes = (firstImg.getAttribute('sizes') || '100vw').replace(/^\s*auto\s*,\s*/, '');
      var fit = getComputedStyle(firstImg).objectFit || 'cover';

      var layer = document.createElement('div');
      layer.className = 'se-cs-layer' + (FAST[handle] ? ' se-cs-fast' : '');
      layer.setAttribute('aria-hidden', 'true');
      var a = document.createElement('img'), b = document.createElement('img');
      [a, b].forEach(function (im) {
        im.className = 'se-cs-img';
        im.alt = '';
        im.decoding = 'async';
        im.loading = 'lazy';
        im.sizes = sizes;
        im.style.objectFit = fit;
        layer.appendChild(im);
      });
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(layer);

      var links = Array.prototype.slice.call(cardEl.querySelectorAll('a[href*="/products/"]'))
        .filter(function (x) { return handleFromHref(x.getAttribute('href')) === handle; });

      var card = {
        el: cardEl, handle: handle, colors: colors, idx: start, layer: layer, front: a, back: b,
        I: FAST[handle] ? (RM ? FAST_I_RM : FAST_I) : CFG.interval,
        orig: FAST[handle] ? normalize(raw) : null, // design order as listed on the product (shared by mat + clutch)
        fastIdx: FAST[handle] ? fastN : -1,
        off: FAST[handle] ? Math.round(FAST_OFF[fastN++ % 8] * normalize(raw).length / 8) : 0,
        links: links, sizes: sizes, timer: null, visible: false, hover: false, touchUntil: 0, dead: false,
        // Fixed phase within the shared cycle: index * STEP + a small random jitter.
        phase: ((order * STEP + (Math.random() * 2 - 1) * 0.025) % 1 + 1) % 1,
        first: true
      };
      cards.push(card);
      if (GROUPS[handle]) { cardEl.setAttribute('data-se-group-lead', handle); retitle(cardEl, GROUPS[handle]); }
      setLink(card, colors[start]);
      cardEl.setAttribute('data-se-color', colors[start].c);
      cardEl.setAttribute('data-se-shown', colors[start].c);

      // Pause on hover (mouse) and touch.
      cardEl.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && !FAST[handle]) { card.hover = true; } }); // flash cards keep time
      cardEl.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { card.hover = false; schedule(card); } });
      // Touch: a press pauses colour cards briefly; a finger scrolling past (touchmove) does not.
      // flash-designs cards never pause on touch (a tap just opens the product).
      if (!FAST[handle]) {
        cardEl.addEventListener('touchstart', function () { card.touchUntil = Date.now() + CFG.resumeAfterTouch; }, { passive: true });
        cardEl.addEventListener('touchmove', function () { card.touchUntil = 0; }, { passive: true });
      }

      // If the shopper picks a swatch on the card, hand control back to the theme.
      cardEl.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('swatches-variant-picker-component, variant-picker, .variant-option, [ref="swatches"]')) destroy(card);
      });

      io && io.observe(cardEl);
      if (io && FAST[handle]) schedule(card); // flash cards take their clock design right away
      if (!io) { card.visible = true; schedule(card); }
    });
  }

  // ---- Neighbour-aware colour choice -------------------------------------------------------
  // Compare colour FAMILIES, not names: "Navy" and "True Navy", "Ivory" and "White", "Ash" and
  // "Sport Grey" look the same on a card, so they count as a match.
  var FAMILIES = [
    ['navy', /navy/], ['black', /black|charcoal/], ['pink', /pink|blossom|rose|berry|peach|coral/],
    ['green', /mint|sage|green|olive|moss/], ['blue', /blue|chambray|denim|aqua|teal/],
    ['white', /white|ivory|cream|natural|bone/], ['grey', /gr[ae]y|ash|heather$/],
    ['yellow', /butter|yellow|gold|mustard/], ['sand', /sand|khaki|tan|beige|oat|camel/]
  ].concat(window.SE_COLOR_FAMILIES || []);
  var famCache = {};
  function ck(c) {
    if (!c) return '';
    var name = String(c.c || '').toLowerCase().trim();
    if (famCache[name] == null) {
      famCache[name] = name;
      for (var i = 0; i < FAMILIES.length; i++) if (FAMILIES[i][1].test(name)) { famCache[name] = FAMILIES[i][0]; break; }
    }
    return famCache[name];
  }
  // Cards that touch this one in the grid as it is rendered right now (left, right, above, below,
  // diagonals). Uses live layout, so it follows any column count and window resize.
  function neighbours(card) {
    var r = card.el.getBoundingClientRect();
    if (!r.width || !r.height) return [];
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    return cards.filter(function (o) {
      if (o === card || o.dead) return false;
      var q = o.el.getBoundingClientRect();
      if (!q.width || !q.height) return false;
      var dx = Math.abs(q.left + q.width / 2 - cx), dy = Math.abs(q.top + q.height / 2 - cy);
      return (dx > 1 || dy > 1) && dx < r.width * 1.5 && dy < r.height * 1.5;
    });
  }
  // Next colour in this card's rotation that no neighbour shows now (or is fading to/from), preferring
  // one no neighbour plans to change to next. If every option clashes: hold the current colour for
  // this beat when it is itself clash-free, otherwise take the least-used option.
  // flash-designs: the design for clock tick k is orig[(k + off) % n]; every flash card runs on the same
  // tick, so cards with different offsets can never show the same design.
  // v8: flash cards can list different numbers of designs (mat 19, clutch 8), so their clocks drift past
  // each other. A card checks the designs every earlier flash card (lower fastIdx) shows at the same tick;
  // on a clash it jumps half a cycle ahead (then +1, +2, ...) so it never repeats its previous design.
  function fastName(card, k, depth) {
    var o = card.orig, n = o.length, base = ((k + card.off) % n + n) % n, taken = {};
    depth = depth || 0;
    if (depth < 6) cards.forEach(function (x) {
      if (x !== card && !x.dead && x.orig && FAST[x.handle] && x.fastIdx > -1 && x.fastIdx < card.fastIdx)
        taken[fastName(x, k, depth + 1)] = 1;
    });
    if (!taken[o[base].c]) return o[base].c;
    var half = Math.floor(n / 2), tries = [half];
    for (var j = 1; j < n; j++) if (j !== half) tries.push(j);
    for (var t = 0; t < tries.length; t++) { var nm = o[(base + tries[t]) % n].c; if (!taken[nm]) return nm; }
    return o[base].c;
  }
  function fastTarget(card, k) {
    var name = fastName(card, k);
    for (var i = 0; i < card.colors.length; i++) if (card.colors[i].c === name) return i;
    return (card.idx + 1) % card.colors.length;
  }
  function chooseNext(card, ahead) {
    if (FAST[card.handle] && card.orig) return fastTarget(card, (card.tick || 0) + (ahead || 0));
    var n = card.colors.length, mine = ck(card.colors[card.idx]);
    if (n < 2) return card.idx;
    if (FAST[card.handle]) return (card.idx + 1) % n; // flash-designs: show every design in order
    var now = {}, soon = {};
    neighbours(card).forEach(function (o) {
      var a = ck(o.colors[o.idx]); now[a] = (now[a] || 0) + 1;
      if (o.pending) { var p = ck(o.pending); now[p] = (now[p] || 0) + 1; }
      if (o.leaving) { var l = ck(o.leaving); now[l] = (now[l] || 0) + 1; } // still fading out
      if (o.plan) { var q = ck(o.plan); soon[q] = (soon[q] || 0) + 1; }
    });
    var best = -1, bestScore = Infinity;
    for (var k = 1; k < n; k++) {
      var i = (card.idx + k) % n, key = ck(card.colors[i]);
      if (key === mine) continue;
      var score = (now[key] || 0) * 100 + (soon[key] || 0);
      if (score === 0) { card.lastScore = 0; return i; }
      if (score < bestScore) { best = i; bestScore = score; }
    }
    card.lastScore = bestScore;
    if (best > -1 && bestScore >= 100 && !now[mine]) return card.idx; // hold: changing would create a match
    return best > -1 ? best : (card.idx + 1) % n;
  }

  function destroy(card) {
    card.dead = true;
    clearTimeout(card.timer);
    card.layer.remove();
  }

  function paused(card) {
    return card.dead || card.hover || !card.visible || document.hidden || Date.now() < card.touchUntil;
  }

  // Load ONLY the next color's image into the hidden layer, at the card's own sizes.
  function loadInto(im, c, sizes) {
    if (im.__u === c.u && im.complete && im.naturalWidth) return Promise.resolve();
    im.__u = c.u;
    im.loading = 'eager';
    var host = im.parentElement;
    var nw = needWidth(host);
    im.sizes = sizesFor(host) || sizes;
    // srcset only offers widths >= what this card needs, so a phone (DPR 2-3) never gets a soft image
    im.srcset = CFG.widths.filter(function (w) { return w >= nw; }).concat([nw]).sort(function (a, b) { return a - b; })
      .filter(function (w, i, a) { return a.indexOf(w) === i; })
      .map(function (w) { return withWidth(c.u, w) + ' ' + w + 'w'; }).join(', ');
    im.src = withWidth(c.u, nw);
    return settle(im);
  }

  // Resolve once the image has really loaded (or failed / 5s timeout), then try decode() for at most 1.2s.
  // Never rejects and never hangs, so a card can't freeze on one design (seen with Safari's decode()).
  function settle(im) {
    return new Promise(function (res) {
      var t;
      function ok() { clearTimeout(t); im.removeEventListener('load', ok); im.removeEventListener('error', ok); res(); }
      if (im.complete && im.naturalWidth) return res();
      im.addEventListener('load', ok); im.addEventListener('error', ok);
      t = setTimeout(ok, 5000);
    }).then(function () {
      if (!im.naturalWidth || !im.decode) return;
      return Promise.race([im.decode().catch(function () {}), new Promise(function (r) { setTimeout(r, 1200); })]);
    });
  }

  function step(card) {
    card.timer = null;
    var firstFlash = FAST[card.handle] && !card.shownOnce && !card.dead && !document.hidden; // set its clock design even below the fold
    if (paused(card) && !firstFlash) { schedule(card); return; }
    if (card.finish) card.finish(); // previous fade still pending: settle it first
    if (FAST[card.handle]) card.tick = Math.floor((Date.now() + 150) / card.I);
    var next = chooseNext(card);
    if (next === card.idx) { STATS.holds++; card.plan = null; schedule(card); return; } // hold this beat
    STATS.changes++; if (card.lastScore >= 100) STATS.forced++;
    card.pending = card.colors[next]; // neighbours treat this as shown from now on
    card.pendingAt = Date.now();
    card.plan = null;
    var incoming = card.back, outgoing = card.front;
    loadInto(incoming, card.colors[next], card.sizes).then(function () {
      card.pending = null;
      if (card.dead) return;
      if (paused(card) && card.shownOnce) { schedule(card); return; }
      if (!incoming.naturalWidth) { STATS.holds++; incoming.__u = null; schedule(card); return; } // failed load: keep current image
      // Incoming fades in on top; outgoing stays opaque underneath until the fade is done.
      var instant = FAST[card.handle] && !card.shownOnce; // first flash change: swap at once (the card's own photo is design 1)
      card.shownOnce = true;
      if (instant) incoming.style.transition = 'none';
      outgoing.classList.remove('is-top');
      incoming.classList.add('is-top');
      void incoming.offsetWidth;
      incoming.classList.add('is-on');
      if (instant) { void incoming.offsetWidth; incoming.style.transition = ''; }
      card.front = incoming; card.back = outgoing;
      card.leaving = card.colors[card.idx]; // still visible underneath until the fade really ends
      card.idx = next;
      // Finish when the fade has actually ended (transitionend; timer only as a fallback, since a busy
      // page can run the CSS fade late). Then drop the old image, and only then pick the likely next
      // colour (re-checked when the change is due) and preload just that image into the hidden layer.
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        card.finish = null;
        incoming.removeEventListener('transitionend', onEnd);
        if (card.front !== outgoing) outgoing.classList.remove('is-on');
        card.leaving = null;
        if (card.dead || card.front !== incoming) return;
        card.el.setAttribute('data-se-shown', card.colors[card.idx].c);
        var pi = chooseNext(card, 1);
        card.plan = pi === card.idx ? null : card.colors[pi];
        if (card.plan) loadInto(outgoing, card.plan, card.sizes);
      }
      function onEnd(e) { if (e.target === incoming && e.propertyName === 'opacity') finish(); }
      incoming.addEventListener('transitionend', onEnd);
      card.finish = finish;
      setTimeout(finish, Math.min(CFG.fade + 1500, card.I - 100));
      setLink(card, card.colors[next]);
      card.el.setAttribute('data-se-color', card.colors[next].c);
      schedule(card);
    });
  }

  // Next change = the next moment this card's phase comes round on the shared clock, so
  // neighbouring cards (different phases) never change together and never drift into step.
  function schedule(card) {
    if (card.timer || card.dead) return;
    var now = Date.now(), I = card.I || CFG.interval;
    if (FAST[card.handle] && card.orig) { // shared clock: next tick boundary; the very first change runs now
      card.tick = Math.floor(now / I);
      var at2 = card.first ? now : (card.tick + 1) * I + 20;
      card.first = false;
      card.timer = setTimeout(function () { step(card); }, Math.max(0, at2 - now));
      return;
    }
    var earliest = now + (card.first ? I * 0.5 : I * 0.35);
    if (now < card.touchUntil) earliest = Math.max(earliest, card.touchUntil + 200);
    var k = Math.ceil((earliest - T0) / I - card.phase);
    var at = T0 + (k + card.phase) * I + (Math.random() * 2 - 1) * Math.min(CFG.jitter, 60);
    if (card.first && card.visible) { // warm the first change
      var fi = chooseNext(card);
      card.plan = fi === card.idx ? null : card.colors[fi];
      if (card.plan) loadInto(card.back, card.plan, card.sizes);
    }
    card.first = false;
    card.timer = setTimeout(function () { step(card); }, Math.max(0, at - now));
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var card = cards.filter(function (c) { return c.el === en.target; })[0];
      if (!card) return;
      var was = card.visible;
      card.visible = en.isIntersecting;
      if (!card.visible) return;
      // a flash card scrolling into view catches up to the shared clock now (not on the next tick)
      if (!was && FAST[card.handle] && card.orig && card.shownOnce && card.timer && !card.pending) { clearTimeout(card.timer); card.timer = null; step(card); }
      else schedule(card);
    });
  }, { rootMargin: '100px 0px' }) : null;

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) cards.forEach(schedule);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) cards.forEach(schedule); }); // back/forward cache
  // Watchdog: any visible card with no timer and no load in flight (or one stuck > 7s) gets rescheduled.
  setInterval(function () {
    var now = Date.now();
    cards.forEach(function (c) {
      if (c.dead || c.timer || !c.visible || document.hidden) return;
      if (c.pending && now - (c.pendingAt || 0) < 7000) return;
      if (c.pending) { c.pending = null; STATS.revived = (STATS.revived || 0) + 1; }
      schedule(c);
    });
  }, 2000);
  if (rm && rm.addEventListener) rm.addEventListener('change', function (e) { if (e.matches) cards.forEach(function (c) { if (!FAST[c.handle]) destroy(c); }); });

  var SEL = 'product-card, .product-card';
  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(setup);
  }
  function init() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SEL)) setup(n); else scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.SEColorShuffle = { cards: cards, config: CFG, stats: STATS };
})();
